module.exports = __webpack_public_path__ + "img/icon-low-gas-battery.ae6f973f.svg";